import React, { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { getNextDay } from 'src/common/utils/dateHelpers';
import getClassNames from 'src/common/utils/getClassNames';
import styles from './SnoozeStatus.module.scss';

export type SnoozeStatusProps = {
  reason: string;
  endDate: string;
  snoozeActive?: boolean;
  variant?: 'desktop' | 'drawer';
};

const SnoozeStatus: FC<SnoozeStatusProps> = ({
  reason, endDate, snoozeActive, variant,
}) => {
  const [t] = useTranslation('listing-page');
  if (!snoozeActive || !endDate) return null;
  const formattedDate = getNextDay(endDate);

  return (
    <div className={getClassNames(styles, 'root', variant)}>
      <h3 className={styles.title}>
        {t('snooze-status--title')}
        <span>{t(`snooze-status--reason--${reason}`)}</span>
      </h3>
      <p className={styles.date}>
        {t('snooze-status--date', { date: formattedDate })}
      </p>
      <p className={styles.description}>
        {t('snooze-status--description')}
      </p>
    </div>
  );
};

export default SnoozeStatus;
